















import { mapState, mapMutations } from 'vuex';
import { Vue, Component } from 'vue-property-decorator';
import { MutationTypes, Toast } from '../store/toast';
import ToastComponent from './Toast.vue';

@Component({
  components: {
    ToastComponent,
  },
  computed: mapState(['toast']),
  methods: mapMutations(MutationTypes),
})
export default class ToastContainer extends Vue {
  toast!: Toast[];
}
